import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=js"

import "./ScrollToTop.vue?vue&type=style&index=0&id=54a0300c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a0300c"]])

export default __exports__